/**
 * 设备 ID — 客户端生成并持久化，Refresh 时绑定
 */

import { DEVICE_ID_KEY } from '@/config/constants'
import { getStorage, setStorage } from '@/utils/storage'
import { randomId } from '@/utils/id'

export function getDeviceId(): string {
  let id = getStorage<string>(DEVICE_ID_KEY)
  if (!id) {
    id = randomId()
    setStorage(DEVICE_ID_KEY, id)
  }
  return id
}
